import type { IDataFilters } from "./interfaces";

/**
 * Normalizes filters into the exact body shape the API expects.
 *
 * - Drops any of the three arrays that are empty (an empty `value: []` on a
 *   select filter would match zero rows instead of "no filter").
 * - Returns `null` when nothing is set, so the request body becomes `null`
 *   (unfiltered dataset) rather than `{}`.
 */
export function buildFilterRequestBody(
  filters: IDataFilters | undefined,
): IDataFilters | null {
  const selectFilters = filters?.selectFilters?.filter(
    (f) => f.value.length > 0,
  );
  const exactMatchFilters = filters?.exactMatchFilters;
  const rangeFilters = filters?.rangeFilters;

  const body: IDataFilters = {};
  if (selectFilters && selectFilters.length > 0) {
    body.selectFilters = selectFilters;
  }
  if (exactMatchFilters && exactMatchFilters.length > 0) {
    body.exactMatchFilters = exactMatchFilters;
  }
  if (rangeFilters && rangeFilters.length > 0) {
    body.rangeFilters = rangeFilters;
  }

  return Object.keys(body).length > 0 ? body : null;
}
